import {useQuery} from '@tanstack/react-query'
import {SystemRole} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {getClientRoleList, getUserRoleInfo} from '../RoleEndPoint'

export function setStorageRoleConfiguration(data) {
    localStorage.setItem('roleConfig', JSON.stringify(data))
}

export function getStorageRoleConfiguration() {
    const storageRoleConfiguration = localStorage.getItem('roleConfig')

    if (!storageRoleConfiguration || storageRoleConfiguration === 'undefined') {
        return {}
    }

    try {
        return JSON.parse(storageRoleConfiguration)
    } catch {
        return {}
    }
}

export const useManagementRoleList = (
    requestorId,
    simple,
    filterRequest,
    enabled,
) => {
    const {rolePermissionKeys} = QueryKeyManager(
        QueryKeyTypes.role,
        requestorId,
    )
    return useQuery({
        queryKey: rolePermissionKeys.list({
            simple,
            filterRequest,
        }),
        queryFn: () => getClientRoleList(requestorId, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const useUserRolePermissions = (requestorId, hospitalId, userRole) => {
    const {rolePermissionKeys} = QueryKeyManager(
        QueryKeyTypes.role,
        requestorId,
    )
    return useQuery({
        queryKey: rolePermissionKeys.detail({id: requestorId, hospitalId}),
        queryFn: () => getUserRoleInfo(requestorId, hospitalId),
        enabled:
            !!requestorId &&
            !!hospitalId &&
            userRole === SystemRole.USER_WITH_ROLE,
        placeholderData: getStorageRoleConfiguration() || {},
    })
}
